"use strict";
/*******************************************************************************

    Contains the type of data provided by the Stoa API

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceType = void 0;
/**
 * The type of balance
 */
var BalanceType;
(function (BalanceType) {
    BalanceType[BalanceType["spendable"] = 0] = "spendable";
    BalanceType[BalanceType["frozen"] = 1] = "frozen";
    BalanceType[BalanceType["locked"] = 2] = "locked";
})(BalanceType = exports.BalanceType || (exports.BalanceType = {}));
//# sourceMappingURL=Types.js.map